module.exports = __webpack_public_path__ + "static/conceptSmall3-b9874c00384f624cfdeef2cc21dc0af6.jpg";